import React from "react";
import { ArrowBack, FipayMobile, fipay } from "../../../public/assets";
import { styled } from "styled-components";
import { useNavigate } from "react-router-dom";

const AccountTransferNavbar = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/dashboard/accounts");
  };
  const handleFipayClick = () => {
    navigate("/");
  };

  return (
    <NavbarWrapper>
      <Logo>
        <img
          src="/assets/icons/arrowBack.svg"
          alt="Back Arrow"
          onClick={handleBack}
        />
        <FipayLogo
          src="/assets/icons/fipay.svg"
          alt="Fipay logo"
          onClick={handleFipayClick}
        />
        <FipayMobileLogoWrap
          src="/assets/icons/fipay-mobile.svg"
          alt="fipaylogo"
        />
      </Logo>
    </NavbarWrapper>
  );
};

export default AccountTransferNavbar;

export const NavbarWrapper = styled.div`
  width: auto;
  height: 7rem;
  @media screen and (max-width: 767px) {
    height: 3.6rem;
  }
`;
export const FipayMobileLogoWrap = styled.img`
  display: none;
  @media only screen and (max-width: 767px) {
    display: flex;
  }
`;
export const FipayLogo = styled.img`
  display: flex;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;
export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-items: flex-start;
  gap: 0.5rem;
  padding: 2rem;
  @media screen and (max-width: 767px) {
    padding: 0.5rem;
  }
`;
